export const COOKIES_NAME_CONFIG = {
  ACCESS_TOKEN: "pos_access_token",
  REFRESH_TOKEN: "pos_refresh_token",
  USER_DATA: "pos_user_data",
  TENANT_CONTEXT: "pos_tenant_context",
  SESSION_ID: "pos_session_id",
  XSRF_TOKEN: "pos_xsrf_token",
};
